import { render, staticRenderFns } from "./OldArchive.vue?vue&type=template&id=2abf012c&scoped=true&"
import script from "./OldArchive.vue?vue&type=script&lang=js&"
export * from "./OldArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf012c",
  null
  
)

export default component.exports